import { initialState } from "../../init/initialState";
import {
    ADD_ERR_DESCRIPTION_EMPLOYEE_LIST,
    ADD_SUBSTITUTION, CLEAR_EMPLOYEE_DETAIL_INFORMATION, CLEAR_EMPLOYEE_LIST, CLEAR_ERROR_DESCRIPTION_EMPLOYEE_LIST,
    DELETE_SUBSTITUTION, GET_EMPLOYEE_DETAIL_INFORMATION,
    GET_EMPLOYEE_LIST,
} from "../../enums/MyDivision/EmployeeList/EmployeeListTypes";
import {
    CLEAR_AVAILABLE_EMPLOYEES_DELEGATION, CLEAR_ERROR_NOTIFICATION_CONTENT, GET_ACTIVE_DELEGATIONS,
    GET_AVAILABLE_DELEGATION_TYPES,
    GET_AVAILABLE_EMPLOYEES_DELEGATION, GET_AVAILABLE_SUBSTITUTION_TYPES, GET_ERROR_NOTIFICATION_CONTENT,
} from "../../enums/MyDivision/Delegation/AuthorityDelegation.types";
import {
    CLEAR_DELEGATIONS_IN_PROGRESS,
} from "../../enums/MyDivision/Delegation/AuthorityRevocation";
import {
    CLEAR_AVAILABLE_EMPLOYEES,
    CLEAR_REQUESTS_DELEGATION, DELETE_REQUEST_DELEGATION,
    GET_ACTIVE_REQUESTS_DELEGATIONS, GET_AVAILABLE_REQUESTS,
    GET_ELIGIBLE_DELEGATE_STRUCTS, CLEAR_ELIGIBLE_DELEGATE_STRUCTS,
    GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES, CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES,
} from "../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const myDivisionReducer = (state = initialState, action) => {

    switch (action.type) {
    case GET_ACTIVE_DELEGATIONS:
        return {
            ...state, activeSubstitution: action.payload,
        };

    case GET_AVAILABLE_SUBSTITUTION_TYPES:
        return {
            ...state, availableSubstitutionTypes: action.payload,
        };
    case GET_AVAILABLE_DELEGATION_TYPES:
        return {
            ...state, availableDelegationTypes: action.payload,
        };
    case GET_AVAILABLE_EMPLOYEES_DELEGATION:
        return {
            ...state, availableEmployees: action.payload,
        };
    case CLEAR_AVAILABLE_EMPLOYEES_DELEGATION:
        const { availableEmployees } = state;
        if (availableEmployees) {
            const temp = state;
            delete temp.availableEmployees;
            return temp;
        }
        return state;
    case GET_ERROR_NOTIFICATION_CONTENT:
        return {
            ...state,
            errorNotificationContent: action.payload,
        };
    case CLEAR_ERROR_NOTIFICATION_CONTENT:
        const { errorNotificationContent } = state;
        if (errorNotificationContent) {
            const temp = state;
            delete temp.errorNotificationContent;
            return temp;
        }
        return state;
    case CLEAR_DELEGATIONS_IN_PROGRESS:
        const { activeSubstitution } = state;
        if (activeSubstitution) {
            const temp = state;
            delete temp.activeSubstitution;
            return temp;
        }
        return state;
    case GET_EMPLOYEE_LIST:
        return { ...state, employeeList: action.payload };
    case CLEAR_EMPLOYEE_LIST:
        return { ...state, employeeList: null };
    case ADD_SUBSTITUTION:
        return {
            ...state, employeeList: state.employeeList.map(employee => {
                if (employee.pid === action.payload.pid) {
                    return {
                        ...employee, substitutions: [
                            {
                                id: action.payload.id,
                                from: action.payload.from,
                                to: action.payload.to,
                            },
                        ],
                    };
                } else {
                    return employee;
                }
            }),
        };
    case DELETE_SUBSTITUTION:
        const filterredArray = state.activeSubstitution.filter((el) =>  el.id !== action.payload);
        return {
            ...state, activeSubstitution: filterredArray,
        };
    case ADD_ERR_DESCRIPTION_EMPLOYEE_LIST:
        return {
            ...state,
            processingError: action.payload,
        };
    case CLEAR_ERROR_DESCRIPTION_EMPLOYEE_LIST:
        if (state.processingError) {
            const temp = { ...state };
            delete temp.processingError;
            return temp;
        }
        return state;

    case GET_EMPLOYEE_DETAIL_INFORMATION:
        return {
            ...state,
            employeeInformation: action.payload,
        };
    case CLEAR_EMPLOYEE_DETAIL_INFORMATION:
        const temp = { ...state };
        delete temp.employeeInformation;
        return temp;
        //REQUESTS DELEGATION
    case GET_ACTIVE_REQUESTS_DELEGATIONS:
        return {
            ...state, requestsDelegations: action.payload,
        };

    case CLEAR_REQUESTS_DELEGATION:
        const { requestsDelegations } = state;
        if (requestsDelegations) {
            const temp = state;
            delete temp.activeSubstitution;
            return temp;
        }
        return state;
    case DELETE_REQUEST_DELEGATION:
        return {
            ...state, requestsDelegations:   state.requestsDelegations.filter((el) =>  el.id !== action.payload),
        };
        case GET_AVAILABLE_REQUESTS:
            return {
                ...state,
                availableRequestTypes: action.payload,
            }

    case GET_ELIGIBLE_DELEGATE_STRUCTS:
        return {
            ...state, eligibleDelegateStructs: action.payload,
        };
    case CLEAR_ELIGIBLE_DELEGATE_STRUCTS:
        return {
            ...state, eligibleDelegateStructs: null,
        };
    case GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES:
        return {
            ...state,
            eligibleDelegateStructEmployees: action.payload.employees,
            eligibleDelegateStructEmployeesLimitExceeded: action.payload.limitExceeded,
        };
    case CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES:
        return {
            ...state,
            eligibleDelegateStructEmployees: null,
            eligibleDelegateStructEmployeesLimitExceeded: false,
        };

        //REQUESTS DELEGATION
    default:
        return state;
    }
};
